import React from 'react';
import _ from 'lodash';

import component, {classnames} from './../component';
import TopBanner from './../TopBanner';
import Games from './../Games';
import {Tabs, Tab} from './../Tabs';
import {HBox, VBox} from './../Box';
import LinkButton from './../LinkButton';
import teamRoles from './../teamRoles';
import moment from 'moment';
import {Warning, Check, Caution} from './../icons';
import Api from './../../api';
import Indicator from './../Indicator';
import Link from './../Link';
import tournamentStatuses from './../tournamentStatuses'
import tournamentApplicationStatuses from './../tournamentApplicationStatuses'
import Ellipsis from './../MultilineEllipsis';

import {Page} from './Page';
import {dateTime, dateTimeYear} from './../DateFormats';

import notices from './../notices';

const setPopup = (params) => {
  params.data.cursor('popup').set({
    icon: params.icon,
    message: params.html,
    links: params.links,
    action: params.action,
    iconWidth: 128,
    iconHeight: 128,
    autoClose: true
  })
};

export function displayDateRangeTitle(dates, one, period){
  const start = moment(dates.get('from')).format('DD.MM.YYYY');
  const end = moment(dates.get('to')).subtract(1, 'day').format('DD.MM.YYYY');
  return start === end ? one : period;
}

export function displayDateRange(dates, finished=false, preposition='', delimiter=' – ', short=false){
  const start = finished ? dateTimeYear(dates.get('from'), short) : dateTime(dates.get('from'), short);
  const end = finished ? dateTimeYear(dates.get('to'), short) : dateTime(dates.get('to'), short);
  return start === end ? <nobr>{start}</nobr> : <span><nobr>{preposition+' '+start+''+delimiter}</nobr><wbr/><nobr>{end}</nobr></span>;
}

const TournamentApplication = component('TournamentApplication', {
  getInitialState() {
    let state = {};
    const user = this.props.data.cursor('user');
    state.isAuthorized = user.hasData();
    state.hasTeam = user.get('has_team');
    state.isCaptain = user.get('member_role') === teamRoles.captain.id;

    const team = this.props.data.cursor(['teamData', this.props.data.cursor('team').getIn('id')]);
    let firstTeam = null;
    if(team && team.cursor(['members']).hasData()) {
      firstTeam = team.cursor(['members']).map(p => p.get('role') === teamRoles.main.id).filter(b => b);
    }

    let teamApplication = _.find(this.props.tournament.get('teams').toJS(), {id: team.get('id')});
    if (teamApplication) {
      var teamApplicationStatus = _.findKey(tournamentApplicationStatuses, {id: teamApplication.application_status});
    }

    const now = new Date().getTime();
    state.enoughPlayers = firstTeam && firstTeam.size >= 4;
    state.registrationPeriod = tournamentStatuses.registration.id === this.props.tournament.get('status');
    state.registered = teamApplicationStatus === 'new' || teamApplicationStatus === 'approved';
    state.approvePeriod = tournamentStatuses.confirmation.id === this.props.tournament.get('status');
    state.registrationClosed = (
      tournamentStatuses.registration_closed.id === this.props.tournament.get('status')
      ||
      this.props.tournament.get('applications_count') >= this.props.tournament.get('team_limit')
    );
    state.approved = teamApplicationStatus === 'approved';

    return state;
  },

  _makeWarning: function() {
    const warning = [
      {
        show: !this.state.isAuthorized,
        text: notices.tournamentRegisterNeedAuth,
        action: 'Ok'
      },
      {
        show: !this.state.hasTeam,
        text: notices.tournamentRegisterNeedTeam,
        links: [
          {
            name: 'teamsNew',
            text: 'Создать команду'
          },
          {
            name: 'teams',
            query: {
              sort: 'member_count'
            },
            text: 'Найти команду'
          }
        ]
      },
      {
        show: !this.state.isCaptain,
        text: notices.tournamentRegisterNeedToBeCaptain,
        action: 'Ok'
      },
      {
        show: !this.state.enoughPlayers,
        links: [
          {
            name: 'teamDetails',
            params: {
              id: this.props.data.getIn(['team', 'id'])
            },
            text: 'Перейти на страницу команды'
          },
          {
            name: 'teams',
            query: {
              sort: 'member_count'
            },
            text: 'Найти команду'
          }
        ],
        text: notices.tournamentRegisterNeedMorePlayers
      }
    ];

    const messageParams =  _.where(warning, {show: true})[0];

    setPopup({
      data: this.props.data,
      html: messageParams.text,
      icon: Caution,
      links: messageParams.links,
      action: messageParams.action
    });
  },

  _registerTeam: async function () {
    if (!this.state.enoughPlayers || !this.state.hasTeam || !this.state.isCaptain || !this.state.isAuthorized) {
      this._makeWarning();
    } else {
      const tournamentId = this.props.tournament.get('id');
      await Api.captainApplyTeamToTournament({tournamentId});
      setPopup({
        data: this.props.data,
        html: notices.tournamentRegisterSuccess,
        icon: Check,
        action: 'Ok'
      });
      this.state.registered = true;
      const response = await Api.tournamentsRead(tournamentId);
      this.props.data.cursor(['tournamentData', tournamentId]).set(response.data);
      this.setState(this.state);
    }
  },

  _approveTeam: async function () {
    if (!this.state.enoughPlayers || !this.state.hasTeam || !this.state.isCaptain) {
      this._makeWarning();
    } else {
      const tournamentId = this.props.tournament.get('id');
      await Api.captainConfirmTeamToTournament({tournamentId});
      setPopup({
        data: this.props.data,
        html: notices.tournamentRegisterApproveSuccess,
        icon: Check,
        action: 'Ok'
      });
      this.state.approved = true;
      const response = await Api.tournamentsRead(tournamentId);
      this.props.data.cursor(['tournamentData', tournamentId]).set(response.data);
      this.setState(this.state);
    }
  },

  _fakeClick(){},

  _application() {
    if(this.props.tournament.get('private')){
      return null;
    }
    if (this.state.registered) {
      let confirmationDates = this.props.tournament.get('confirmation_dates');
      confirmationDates = confirmationDates ? confirmationDates.toJS() : null;
      if (this.state.approved || !confirmationDates || confirmationDates.from === null && confirmationDates.to === null) {
        return <p className="TournamentApplication-NoticeP">Ваша команда зарегистрирована и допущена к участию.</p>;
      } else {
        if (this.state.approvePeriod) {
          return <LinkButton className='Tournament-LinkButton' onClick={this._approveTeam} text='Подтвердить участие'/>;
        } else {
          return (
            <div className="TournamentApplication-Notice">
              {this.props.tournament.getIn(['confirmation_dates', 'from']) && this.props.tournament.getIn(['confirmation_dates', 'to']) &&
                <p className="TournamentApplication-NoticeP">Подтвердить участие можно будет {displayDateRange(this.props.tournament.get('confirmation_dates'), false, 'в период с', ' по ')}</p>
                || ''
              }
              <LinkButton className='Tournament-LinkButton Tournament-LinkButton--Disabled' onClick={this._fakeClick}  text='Подтвердить участие'/>
            </div>
          );
        }
      }
    } else if (this.state.registrationPeriod) {
      if ( !this.state.registrationClosed ) {
        return <LinkButton className='Tournament-LinkButton' onClick={this._registerTeam} text='Регистрация команды'/>;
      } else {
        return (
          <div className="TournamentApplication-Notice">
            <p className="TournamentApplication-NoticeP">Регистрация закрыта</p>
          </div>
        );
      }
    } else {
      return null;
    }
  },

  render(){
    const application = this._application();
    return application && <div className="Tournament-Application">{application}</div>;
  }
});


const TopBannerContent = component('TopBannerContent', function({data, tournament}){
  if(tournament) {
    const finished = tournament.get('status') === tournamentStatuses.finished.id;
    return (
      <TopBanner align={false} background={tournament.get('image')} size='large'>
        <div className={classnames("Tournament-Logo", !tournament.get('logo') && 'Tournament-LogoEmpty')}  style={{
              backgroundImage: tournament.get('logo') ? `url(${tournament.get('logo')}?resize=1&w=400&h=160)` : 'none'
            }}/>
        <h1 className="Tournament-H1">{tournament.get('title')}</h1>

        <Ellipsis className="Tournament-H2">{tournament.get('description')}</Ellipsis>

        <div className="Tournament-Details">
          {tournament.getIn(['registration_dates', 'from']) && tournament.getIn(['registration_dates', 'to']) &&
            <div className="Tournament-DetailsItem">
              <div className="Tournament-DetailsItemTitle">{displayDateRangeTitle(tournament.get('registration_dates'), 'Дата', 'Период')} регистрации</div>
              <div className="Tournament-DetailsItemValue">{displayDateRange(tournament.get('registration_dates'), finished)}</div>
            </div> || '' }
          {tournament.getIn(['confirmation_dates', 'from']) && tournament.getIn(['confirmation_dates', 'to']) &&
            <div className="Tournament-DetailsItem">
              <div className="Tournament-DetailsItemTitle">{displayDateRangeTitle(tournament.get('confirmation_dates'), 'Дата', 'Период')} подтверждения</div>
              <div className="Tournament-DetailsItemValue">{displayDateRange(tournament.get('confirmation_dates'), finished)}</div>
            </div> || ''}
          {tournament.getIn(['dates', 'from']) && tournament.getIn(['dates', 'to']) &&
            <div className="Tournament-DetailsItem">
              <div className="Tournament-DetailsItemTitle">{displayDateRangeTitle(tournament.get('dates'), 'Дата', 'Период')} проведения</div>
              <div className="Tournament-DetailsItemValue">{displayDateRange(tournament.get('dates'), finished)}</div>
            </div> || ''}
          <div className="Tournament-DetailsItem">
            <div className="Tournament-DetailsItemTitle">КОМАНДЫ</div>
            <div className="Tournament-DetailsItemValue">{tournament.get('teams').size + (tournament.get('team_limit') && '/' + tournament.get('team_limit'))}</div>
          </div>
          {tournament.get('prize') &&
          <div className="Tournament-DetailsItem">
            <div className="Tournament-DetailsItemTitle">ПРИЗ</div>
            <Ellipsis className="Tournament-DetailsItemValue Tournament-DetailsItemValue--Prize">{tournament.get('prize')}</Ellipsis>
          </div>
          }
        </div>
        <TournamentApplication tournament={tournament} data={data}/>
      </TopBanner>
    );
  }else{
    return <TopBanner size='large'><Indicator className="Tournament-MainIndicator" large/></TopBanner>;
  }
});

export default class TournamentDetails extends Page {
  renderLoaded({data, params, content}){
    const tournament = data.getIn(['tournamentData', parseInt(params.id)]);

    const currentRoute = data.get('route').get('name');
    const stageId = params && parseInt(params.stageId, 10);


    let tabs = [];
    if(tournament) {
      tournament.get('stages').map((stage, index)=> {
        tabs.push(<Tab key={'l'+index} selected={(currentRoute === 'tournamentStage' || currentRoute === 'tournamentStageInner') && stageId === stage.get('id')} header={<Link name="tournamentStage" params={{id: params.id, stageId: stage.get('id')}} keepScroll={true}>{stage.get('title')}</Link>}></Tab>);
      });
      tabs.push(<Tab key={'r1'} selected={currentRoute === 'tournamentTeamsList'} header={<Link name='tournamentTeamsList' params={{id: params.id}} keepScroll={true}>Список команд</Link>} stackTo="right"></Tab>);
      tabs.push(<Tab key={'r2'} selected={currentRoute === 'tournamentRules'} header={<Link name='tournamentRules' params={{id: params.id}} keepScroll={true}>Правила</Link>} stackTo="right"></Tab>);
    }

    return (
      <div className="Tournament">
        <TopBannerContent data={data} tournament={tournament}/>
        <Games data={data.cursor('gamesRecent')} />
        <HBox width={4}>
          <Tabs noDefaultSelected={true}>
            {tabs.map((tab)=>(tab))}
          </Tabs>
          {content && content || params.stageId && <Indicator/>}
        </HBox>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/TournamentDetails.js